import { ReactiveFormsModule } from '@angular/forms';

import { HttpClient, HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
// import { SharedModule } from './shared/shared.module';
import { SharedModule } from './shared/shared.module';
import { JwtInterceptor } from './_helpers/http-interceptor';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastrModule } from 'ngx-toastr';
import { PaymentMethodComponent } from './pages/payment-method/payment-method.component';

import { APP_INITIALIZER, ErrorHandler } from "@angular/core";
import { Router, UrlSerializer } from "@angular/router";
import * as Sentry from "@sentry/angular";
import { LowerCaseUrlSerializer } from './_helpers/lowercase-url-serializer';
import { CookieService } from 'ngx-cookie-service';

@NgModule({ declarations: [
        AppComponent,
        PaymentMethodComponent
    ],
    bootstrap: [AppComponent], imports: [BrowserModule.withServerTransition({ appId: 'serverApp' }),
        AppRoutingModule,
        ReactiveFormsModule,
        SharedModule,
        BrowserAnimationsModule,
        ToastrModule.forRoot()], providers: [
        { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
        { provide: UrlSerializer, useClass: LowerCaseUrlSerializer },
        CookieService,
        {
            provide: ErrorHandler,
            useValue: Sentry.createErrorHandler(),
          },
          {
            provide: Sentry.TraceService,
            deps: [Router],
          },
          {
            provide: APP_INITIALIZER,
            useFactory: () => () => {},
            deps: [Sentry.TraceService],
            multi: true,
          },
        provideHttpClient(withInterceptorsFromDi()),
    ] })
export class AppModule { }